import gql from 'graphql-tag';

export default {
  setCrash: gql`
    mutation setCrash($info: String!, $error: String!) {
      setCrash(info: $info, error: $error) {
        id
        hash
      }
    }
  `
};
